/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class PublicBillingSetupAPI extends ApiClient {
  constructor() {
    super('public/billing_setups', { accountScoped: false });
  }

  submit(trialToken, payload) {
    return axios.post(`${this.url}/${trialToken}`, payload);
  }
}

export const publicBillingSetupApi = new PublicBillingSetupAPI();
